"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var inversify_react_1 = require("inversify-react");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./InlineOnboardingPanel.css"));
var c = (0, BemBuilder_1.default)("inline-onboarding-panel");
var InlineOnboardingPanelInner = (0, react_1.forwardRef)(function (_a, ref) {
    var title = _a.title, description = _a.description, onDismiss = _a.onDismiss, onPlay = _a.onPlay, startTour = _a.startTour, tourId = _a.tourId, videoThumbnail = _a.videoThumbnail, imageThumbnail = _a.imageThumbnail;
    var isMobile = (0, inversify_react_1.useInjection)("isMobile");
    var suppressDragBehaviour = function (e) {
        e.stopPropagation();
    };
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(c("inner")), onMouseDown: suppressDragBehaviour },
        react_1.default.createElement(kaleidoscope_2.RainbowBar, { isTopRounded: true }),
        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), size: kaleidoscope_1.ButtonSize.Small, className: c("close-button"), onClick: function () { return onDismiss("x"); } }),
        react_1.default.createElement("div", { className: "".concat(c("content"), " ").concat(isMobile() ? c("content", "mobile") : "") },
            react_1.default.createElement("div", { className: c("image-column") }, imageThumbnail ? (react_1.default.createElement("img", { className: styles.imageCard, src: imageThumbnail })) : (videoThumbnail && (react_1.default.createElement("div", { style: {
                    "--onboarding-video-thumbnail": "url(/Assets/Images/onboarding/".concat(videoThumbnail, ")"),
                } },
                react_1.default.createElement(kaleidoscope_1.ButtonCard, { className: (0, classnames_1.default)(c("image-button")), onClick: function () { return onPlay("image"); } },
                    react_1.default.createElement("div", { className: c("play-ring") },
                        react_1.default.createElement(icons_1.Play, { size: icons_1.IconSize.Large, className: c("play-icon") }))))))),
            react_1.default.createElement("div", { className: c("text-column") },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true, className: c("description-heading") }, title),
                react_1.default.createElement(kaleidoscope_1.Text, { className: c("description-text"), size: "l" }, description),
                react_1.default.createElement("div", { className: c("actions") },
                    tourId ? (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Medium, onClick: function () { return startTour(); } },
                        react_1.default.createElement(icons_1.Discover, null),
                        "Take a tour")) : (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Medium, onClick: function () { return onDismiss("gotit"); } },
                        react_1.default.createElement(icons_1.ThumbsUp, null),
                        "Got it")),
                    videoThumbnail && (react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Medium, onClick: function () { return onPlay("button"); } },
                        react_1.default.createElement(icons_1.Video, null),
                        "Watch video")))))));
});
var InlineOnboardingPanel = function (_a) {
    var show = _a.show, props = __rest(_a, ["show"]);
    var CardWithShadow = function (props) { return react_1.default.createElement(kaleidoscope_1.Card, __assign({}, props, { elevation: 2 })); };
    return (react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: show, timeout: kaleidoscope_3.AnimationDuration.Long, element: CardWithShadow, className: c() }, function (_a) {
        var expandableElementRef = _a.expandableElementRef;
        return react_1.default.createElement(InlineOnboardingPanelInner, __assign({ ref: expandableElementRef }, props));
    }));
};
exports.default = InlineOnboardingPanel;
